
import { ChevronDown, Lock, Unlock } from 'lucide-react';
import Button from '../Button';
import DropdownMenu from '../Dropdown/index';



export type AccessOptionsProps = {
    accessOptions: AccessObject[],
    handleAccessLevelChange: (accessLevel: AccessObject) => void,
    accessLevel: AccessObject,
}

export type AccessObject = {
    value: string,
    label: string,
    description: string,
    is_public: boolean;
}

const AccessOption = ({ accessOptions, handleAccessLevelChange, accessLevel }: AccessOptionsProps) => {

    return (
        <div className="flex justify-between items-center mt-2">
            <div className="flex items-center gap-2">
                <div className="border border-border h-9 w-9 rounded-md items-center justify-center flex">
                    {accessLevel?.value === 'anyone' ? <Unlock size={18} /> : <Lock size={18} />}
                </div>
                <div className="flex flex-col justify-center">
                    <DropdownMenu modal={false}>
                        <DropdownMenu.Trigger asChild>
                            <Button
                                variant="ghost"
                                className="text-sm w-fit px-0 h-4 hover:bg-transparent"
                                tooltip="Select the access level for this project"
                                toolTipPortal
                                size="sm"
                            >
                                {accessLevel?.label}<ChevronDown size={18} />
                            </Button>
                        </DropdownMenu.Trigger>
                        <DropdownMenu.Content
                            container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper') || document.body}
                            align="start"
                            className="min-w-[14rem]"
                            portal
                        >
                            <DropdownMenu.Label>Who can view this?</DropdownMenu.Label>
                            <DropdownMenu.Separator />
                            {
                                accessOptions.map((option) => {
                                    return (
                                        <DropdownMenu.CheckboxItem
                                            onClick={() => handleAccessLevelChange(option)}
                                            checked={accessLevel?.value === option.value}

                                        >
                                            {option.value === 'anyone' ? <Unlock size={16} /> : <Lock size={16} />} {option.label}
                                        </DropdownMenu.CheckboxItem>
                                    );
                                })

                            }

                        </DropdownMenu.Content>
                    </DropdownMenu>
                    <div className="text-sm text-gray-400 leading-tight">{accessLevel?.description}</div>
                </div>
            </div>

        </div>
    );
};

export default AccessOption;
